import { CLASSIFICATION_STATES } from 'containers/ResolutionCenter/AtoIncident/constants'
import { INCIDENT_TYPE } from 'containers/ResolutionCenter/constants'
import {
  ATTACK_STATES,
  REPORT_STATE,
  UNIFIED_REPORT_STATE,
} from 'containers/ResolutionCenter/Report/constants'

// FIXME: need to use INCIDENT_TYPE dynamically
export const isMalicious = (state) =>
  ATTACK_STATES[INCIDENT_TYPE.MAIL].filter((elem) => elem === state).length
export const isSpam = (state) =>
  state === REPORT_STATE.MAIL.MARKED_AS_SPAM || state === REPORT_STATE.MAIL.AUTO_SPAM
export const isSafe = (state) =>
  state === REPORT_STATE.MAIL.FALSE_POSITIVE || state === REPORT_STATE.MAIL.AUTO_SAFE

export const isUnifiedSafe = (state) => state === UNIFIED_REPORT_STATE.SAFE
export const isUnifiedMalicious = (state) => state === UNIFIED_REPORT_STATE.PHISHING
export const isUnifiedSpam = (state) => state === UNIFIED_REPORT_STATE.SPAM
export const isUnifiedCompromised = (state) => state === UNIFIED_REPORT_STATE.COMPROMISED

export const displayState = (state) => {
  if (isSafe(state)) return 'safe'
  else if (isSpam(state)) return 'spam'
  else if (isMalicious(state)) return 'phishing'
  else return null
}

export const displayStateLegacy = (state) => {
  if (isSafe(state)) return 'fp'
  else if (isSpam(state)) return 'spam'
  else if (isMalicious(state)) return 'malicious'
  else return null
}

export const isUnclassifiedReport = (state) =>
  state === REPORT_STATE.MAIL.REPORT && !isSpam(state) && !isMalicious(state) && !isSafe(state)

export const displayUnifiedReportState = (state) => {
  if (isUnifiedSafe(state)) return 'safe'
  else if (isUnifiedSpam(state)) return 'spam'
  else if (isUnifiedMalicious(state)) return 'phishing'
  else if (isUnifiedCompromised(state)) return 'compromised'
  else return null
}

export const isUnclassifedATOIncident = (incident) =>
  !CLASSIFICATION_STATES.find((classifyState) => classifyState.state === incident.state)
